import { useGetInventoryApplication } from "@/api/useInventory"
import { ASCENDING, ORDER_BY, SEEN_TIMESTAMP } from "@/helpers/filters.helper"
import { useQueryString } from "@/hooks/useQueryString"
import { getApplicationTabData } from "./useApplicationInventory.selector"

export const useApplicationInventory = (
  paramKeys?: { key: string }[],
  config?: { enabled: boolean; headers?: Record<string, string> }
) => {
  const keys = [SEEN_TIMESTAMP, ORDER_BY, ASCENDING, ...(paramKeys || [])]
  const params = useQueryString(keys)
  const context = useGetInventoryApplication(params, {
    select: getApplicationTabData,
    ...(config || {})
  })
  return context
}
